/**
 * Home — fase "depois": memória da viagem.
 *
 * As métricas do protótipo (fotos, vídeos, lugares) dependem do módulo de
 * Memórias, que ainda não existe. Enquanto não existir, esta tela mostra o que
 * é verdade: quantos dias, quantas pessoas, quanto o grupo gastou — e o
 * caminho de volta ao roteiro, que virou diário.
 */
import { formatMoney, pluralize } from '@nv/core';
import { useNavigate } from 'react-router-dom';

import { Card, MetricCard } from '../../../ui/primitives';
import { AtalhoDoPassaporte } from '../../carimbos/AtalhoDoPassaporte';
import { DiarioDaViagem } from '../../resumo/ResumoNaHome';
import type { HomeData } from '../data';
import type { TripHeader } from '../model';

export function AfterPhase({
  header,
  data,
  currency,
}: {
  header: TripHeader;
  data: HomeData;
  currency: string;
}) {
  const navigate = useNavigate();

  return (
    <>
      <h1 className="home-ended">{header.name} terminou ❤️</h1>
      <p className="home-dates">
        {header.range} · {pluralize(header.durationInDays, 'dia', 'dias')} ·{' '}
        {pluralize(header.participantCount, 'pessoa', 'pessoas')}
      </p>

      <div className="home-metrics home-metrics--grid">
        <MetricCard
          accent="success"
          label="DIAS"
          value={String(header.durationInDays)}
        />
        <MetricCard
          accent="violet"
          label="DIAS COM PROGRAMAÇÃO"
          value={String(data.preparation.daysPlanned)}
        />
        {data.finance && (
          <MetricCard
            accent="danger"
            label="TOTAL DO GRUPO"
            value={formatMoney(data.finance.groupTotalMinor, currency)}
          />
        )}
      </div>


      <AtalhoDoPassaporte />

      <DiarioDaViagem />

      <Card>
        <div className="home-prep__head">
          <span className="home-prep__title">Diário completo</span>
        </div>
        <p className="home-prep__note">
          Cada dia da viagem, com o que o grupo fez.
        </p>
        <button
          type="button"
          className="nv-btn nv-btn--chip"
          onClick={() => navigate('/roteiro')}
        >
          Abrir o diário
        </button>
      </Card>

      <button
        type="button"
        className="nv-btn nv-btn--primary nv-btn--block"
        onClick={() => navigate('/financeiro/fechar')}
      >
        Fechar as contas
      </button>
    </>
  );
}
